export interface IPreSelectHistoryDetails {
    centerId: number,
    centerAlias: string,
    preSelectAverageDate: string,
    percentPreSelected: number,
    isLowestScore: boolean
}
